import { useState, useEffect } from "react";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import {
  getAllUsers,
  createUser,
  updateUser,
  deleteUser,
  getUserPassword
} from "../../services/utilisateurs"; 
import type { Utilisateur } from "../../types/utilisateur";
import "./GestionUtilisateurs.css";

export default function GestionUtilisateurs() {
  const [utilisateurs, setUtilisateurs] = useState<Utilisateur[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState<Utilisateur | null>(null);
  const [passwords, setPasswords] = useState<{ [key: string]: string }>({});

  // Charger les utilisateurs depuis la BD
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const data = await getAllUsers();
        setUtilisateurs(data);
      } catch (err) {
        console.error("Erreur récupération utilisateurs :", err);
      }
    };
    fetchUsers();
  }, []);

  // Voir mot de passe avec validation superadmin
  const handleVoirMotDePasse = async (userId: string) => {
    const inputPassword = prompt("Entrez votre mot de passe SuperAdmin :");
    if (!inputPassword) return;

    try {
      const password = await getUserPassword(userId, inputPassword);
      if (password) {
        setPasswords((prev) => ({ ...prev, [userId]: password }));
      } else {
        alert("Mot de passe incorrect !");
      }
    } catch (err) {
      console.error("Erreur récupération mot de passe :", err);
      alert("Erreur serveur lors de la vérification.");
    }
  };

  // Créer ou modifier utilisateur (FormData pour gérer la photo)
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);

    try {
      if (selectedUser) {
        await updateUser(selectedUser.id, formData); // ✅ envoie FormData
      } else {
        await createUser(formData); // ✅ envoie FormData
      }
      const data = await getAllUsers();
      setUtilisateurs(data);
      setShowModal(false);
      setSelectedUser(null);
    } catch (err) {
      console.error("Erreur sauvegarde utilisateur :", err);
    }
  };

  // Supprimer utilisateur
  const handleDelete = async (id: string) => {
    if (window.confirm("Confirmer la suppression de cet utilisateur ?")) {
      try {
        await deleteUser(id);
        setUtilisateurs(utilisateurs.filter((u) => u.id !== id));
      } catch (err) {
        console.error("Erreur suppression utilisateur :", err);
      }
    }
  };

  return (
    <div className="gestion-utilisateurs">
      <div className="header">
        <button className="btn-ajout" onClick={() => setShowModal(true)}>
          ➕ Ajouter utilisateur
        </button>
      </div>

      <table className="user-table">
        <thead>
          <tr>
            <th>Photo</th>
            <th>Prénom</th>
            <th>Nom</th>
            <th>Email</th>
            <th>Rôle</th>
            <th>Téléphone</th>
            <th>Créé(e) le</th>
            <th>MDP</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {utilisateurs.map((u) => (
            <tr key={u.id}>
              <td>
                <img
                  src={u.photo || "/assets/user.png"}
                  alt="profil"
                  className="user-photo"
                />
              </td>
              <td>{u.first_name}</td>
              <td>{u.last_name}</td>
              <td>{u.email}</td>
              <td>{u.role}</td>
              <td>{u.numero_tel}</td>
              <td>{new Date(u.date_creation).toLocaleDateString()}</td>
              <td className="password-cell">
                {passwords[u.id] ? passwords[u.id] : "****"}
                <FaEye
                  className="icon-eye"
                  onClick={() => handleVoirMotDePasse(u.id)}
                />
              </td>
              <td className="actions">
                <FaEdit
                  className="icon-edit"
                  onClick={() => {
                    setSelectedUser(u);
                    setShowModal(true);
                  }}
                />
                <FaTrash
                  className="icon-trash"
                  onClick={() => handleDelete(u.id)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>{selectedUser ? "Modifier utilisateur" : "Ajouter utilisateur"}</h3>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="username"
                placeholder="Nom d’utilisateur"
                defaultValue={selectedUser?.username}
              />
              <input
                type="text"
                name="first_name"
                placeholder="Prénom"
                defaultValue={selectedUser?.first_name}
              />
              <input
                type="text"
                name="last_name"
                placeholder="Nom"
                defaultValue={selectedUser?.last_name}
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                defaultValue={selectedUser?.email}
              />
              <select name="role" defaultValue={selectedUser?.role}>
                <option value="superadmin">Superadmin</option>
                <option value="ingenieur">Ingénieur</option>
                <option value="technicien">Technicien</option>
                <option value="ouvrier">Ouvrier</option>
              </select>
              <input
                type="text"
                name="numero_tel"
                placeholder="Téléphone"
                defaultValue={selectedUser?.numero_tel || ""}
              />
              <input type="password" name="password" placeholder="Mot de passe" />
              <input type="file" name="photo" accept="image/*" />
              <div className="modal-actions">
                <button type="submit">Enregistrer</button>
                <button type="button" onClick={() => setShowModal(false)}>
                  Annuler
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
